export default __webpack_public_path__ + "static/media/FDM.9e05b7b1.jpg";